import axios from "axios";
import { invalidateCache } from "../hooks/usePageData";
import { API_BASE_URL } from "./apiConfig";
const API_KEY = (process.env.REACT_APP_API_KEY || "")
  .split(",")
  .map((key) => key.trim())
  .find(Boolean);
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": API_KEY || "",
  },
});
api.interceptors.request.use((config) => {
  try {
    const raw = sessionStorage.getItem("auth_session");
    if (raw) {
      const session = JSON.parse(raw);
      const token = session?.tipo === "admin" ? session?.data?.token : null;
      const studentId =
        session?.tipo === "aluno" ? session?.data?.id || null : null;
      config.headers = config.headers || {};
      if (token) {
        config.headers["X-Admin-Token"] = token;
      }
      if (studentId) {
        config.headers["X-Student-Id"] = String(studentId);
      }
      const learningToken =
        session?.data?.learning_token || session?.data?.learning_admin_token;
      if (learningToken) config.headers["X-Learning-Token"] = learningToken;
    }
  } catch {
    // Ignora erros de leitura da sessao
  }
  return config;
});
const ENDPOINT_TO_COLLECTION = {
  "/houses": "houses",
  "/teachers": "teachers",
  "/activities": "activities",
  "/students": "students",
  "/checkpoints": "checkpoints",
  "/redemptions": "redemptions",
  "/bonus-log": "bonusLog",
  "/batalhas": "batalhas",
  "/transfers": "transfers",
  "/salas": "salas",
  "/agendamentos": "agendamentos",
  "/bloqueios": "bloqueios",
  "/cardapio": "cardapio",
  "/meritos": "meritos",
  "/tempo-estudado": "checkpoints",
};
api.interceptors.response.use(
  (response) => {
    const config = response.config;
    const method = config.method?.toUpperCase();
    if (["POST", "PUT", "DELETE"].includes(method)) {
      const url = config.url || "";
      for (const [endpoint, collection] of Object.entries(
        ENDPOINT_TO_COLLECTION,
      )) {
        if (url.startsWith(endpoint)) {
          invalidateCache(collection);
          break;
        }
      }
    }
    return response;
  },
  (error) => Promise.reject(error),
);
export default api;
export { api };
